export default __webpack_public_path__ + "static/media/Blog12.3.50bb621d.png";